<template>
  <div>
    <b-row>
      <b-col>
        <header-view
          :title="$t('message.contactPersonDetails.title')"
          :icon="'ti-user'">
        </header-view>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <business-card
          :name="name"
          :relation="relationship"
          :email="contactPerson.email"
          :imageSrc="contactPerson.avatarUuid"
          variant="noHover">
        </business-card>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <b-btn
          variant="link"
          to="/contactPersons">
          {{ $t('message.contactPersonDetails.btn.back') }}
        </b-btn>
      </b-col>
      <b-col class="text-right">
        <b-btn
          v-b-modal.delete-contact-person-modal
          class="rounded-0"
          variant="danger">
          {{ $t('message.contactPersonDetails.btn.delete') }}
        </b-btn>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col>
        <contracts-card
          collapseId="contact-persons-contracts-card"
          :items="contracts"
          :title="$t('message.contactPersonDetails.contractsCard.title',
           { firstName: contactPerson.firstName, lastName: contactPerson.lastName })"
          @showDetails="showDetails">
        </contracts-card>
      </b-col>
    </b-row>
    <b-modal id="delete-contact-person-modal"
             cancel-variant="danger"
             ok-variant="success"
             :title="$t('message.contactPersonDetails.modal.title')"
             :ok-title="$t('message.contactPersonDetails.modal.btn.ok')"
             :cancel-title="$t('message.contactPersonDetails.modal.btn.cancel')"
             @ok="deleteContactPerson">
      <p class="mt-4">
        {{ $t('message.contactPersonDetails.modal.question',
        {
        salutation: $t('enums.salutations.' + contactPerson.salutation),
        firstName: contactPerson.firstName,
        lastName: contactPerson.lastName
        })
        }}
      </p>
    </b-modal>
  </div>
</template>

<script>
  import BusinessCard from '@/components/common/BusinessCard'
  import ContractsCard from '@/components/contracts/ContractsCard'
  import HeaderView from '@/components/common/HeaderView'

  export default {
    name: 'ContactPersonDetails',
    components: {
      BusinessCard,
      ContractsCard,
      HeaderView
    },
    computed: {
      contactPerson () {
        return this.$store.getters.contactPerson
      },
      contracts () {
        return this.$store.getters.contractsByContactPerson
      },
      name () {
        return this.contactPerson.firstName + ' ' + this.contactPerson.lastName
      },
      relationship () {
        if (this.contactPerson.relationshipType) {
          return this.$t('enums.relationTypes.' + this.contactPerson.relationshipType)
        }
        return ''
      }
    },
    created () {
      const id = parseInt(this.$route.params.id)
      if (id) {
        const filteredContactPersons = this.$store.getters.contactPersons.filter(contactPerson => contactPerson.id === id)
        if (filteredContactPersons.length === 0) {
          this.$store.dispatch('fetchContactPersonById', id)
            .catch(() => {
              this.showErrorMsg({
                message: this.$t('error.contactPersonDetails.contactPersonById')
              })
              this.$router.replace('/contactpersons')
            })
        } else {
          this.$store.commit('setContactPerson', filteredContactPersons[0])
        }
        this.$store.dispatch('fetchContractsByContactPerson', id)
          .catch(() => {
            this.showErrorMsg({
              message: this.$t('error.contractPersonDetails.fetchContractsByContactPerson')
            })
          })
      } else {
        this.$router.replace('/contactpersons')
      }
    },
    methods: {
      deleteContactPerson () {
        this.$store.dispatch('deleteContactPerson', this.contactPerson.id)
          .then(() => {
            this.showSuccessMsg({
              message: this.$t('message.contactPersonDetails.deleteContactPerson')
            })
            this.$router.push('/contactpersons')
          })
          .catch(() => {
            this.showErrorMsg({
              message: this.$t('error.contactPersonDetails.deleteContactPerson')
            })
          })
      },
      showDetails (contract) {
        this.$router.push(`/contracts/${contract.id}`)
      }
    },
    notifications: {
      showErrorMsg: {
        type: 'error'
      },
      showSuccessMsg: {
        type: 'success'
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/contactPerson/ContactPersonDetails.vue